import React from 'react';
import { compose, withHandlers } from 'recompose';
import { noop } from 'lodash/fp';
import TextInput from '../../../../../common/components/TextInput';
import { REF_TOOLTIP_TEXT } from '../../constants/texts';
import messengerAdsRefHelpImage from 'assets/ads-ref-help-new.png';
import './MessengerAdDetail.scss';

const RefTextInputBase = ({ text, onRefFocus }) => (
  <div className="ad-details__input-container">
    <div className="ad-details__ad-ref-container">
      <div className="ad-details__field-title">URL Parameter</div>
      <div className="ad-details__help-text">
        {REF_TOOLTIP_TEXT}
        <a
          href={messengerAdsRefHelpImage}
          className="ad-details__info-image"
          target="_blank"
          rel="noopener noreferrer"
        >
          View Image
        </a>
      </div>
      <TextInput
        className="ad-details__ad-input"
        value={text}
        onFocus={onRefFocus}
        onChange={noop}
      />
    </div>
  </div>
);

const enhance = compose(
  withHandlers({ onRefFocus: () => e => e.target.select() }),
);

export default enhance(RefTextInputBase);
